<div class="row">
    <div class="col-6">
        <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study-editor.treatment.factor.title' | translate}}" iconClass="bms-icon bms-mgt-details" [helpKey]="HELP_MANAGE_STUDIES_TREATMENT_FACTORS">
            <ng-container>
                <div class="container-fluid px-0">
                    <div class="row pb-2">
                        <div class="col-12 d-flex justify-content-end">
                            <button *ngIf="principal.hasAnyAuthorityDirect(ADD_TREATMENT_FACTORS_VARIABLES_PERMISSIONS)" class="btn btn-outline-info btn-sm ms-1"
                                    (click)="onAddVariableClick()"
                                    title="{{ 'common.add' | translate }}" [disabled]="disableTreatmentFactor">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div class="container-fluid px-0">
                        <div class="custom-scroll-style" style="max-height: 350px; overflow-y: auto; overflow-x: hidden;">
                            <table class="table table-striped table-bordered table-curved mb-0">
                                <thead class="sticky-header">
                                <tr>
                                    <th class="text-center" style="border-top: 0; width: 30px;">
                                    </th>
                                    <th style="width: 150px; border-top: 0;" jhiTranslate="study-editor.variable.column.treatment">
                                        Treatment
                                    </th>
                                    <th style="width: auto; border-top: 0;" jhiTranslate="study-editor.variable.column.label">Label
                                    </th>
                                    <th style="width: auto; border-top: 0;" jhiTranslate="study-editor.variable.column.treatment.no">No of Treatments
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                    @for (treatmentFactor of studyEditorContext.studyDetails.treatmentFactors; track treatmentFactor.levelVariable.termId) {
                                        <tr>
                                            <td>
                                                <button (click)="removeVariable(treatmentFactor.levelVariable)" class="btn btn-link btn-sm"  [disabled]="disableTreatmentFactor">
                                                    <i class="fa fa-minus-circle fa-red fa-2x"></i>
                                                </button>
                                            </td>
                                            <td style="width: 150px;">
                                                <a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                   [queryParams]="{ variableId: treatmentFactor.levelVariable.termId }"
                                                   queryParamsHandling="merge">{{ treatmentFactor.levelVariable.alias || treatmentFactor.levelVariable.name }}</a>
                                            </td>
                                            <td>
                                                @if (disableTreatmentFactor) {
                                                    <a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                       [queryParams]="{ variableId: treatmentFactor.valueVariable.termId }"
                                                       queryParamsHandling="merge">{{ treatmentFactor.valueVariable.alias || treatmentFactor.valueVariable.name }}</a>
                                                } @else {
                                                    <ng-select [items]="pairItemsMap[treatmentFactor.levelVariable.termId]" [(ngModel)]="treatmentFactor.valueVariable" (ngModelChange)="onTreatmentVariableChange($event, treatmentFactor)"
                                                               bindLabel="name"
                                                               appendTo="body"
                                                               [clearable]="false" required>
                                                    </ng-select>
                                                }
                                            </td>
                                            <td>
                                                <input type="number" class="form-control treatment-factor-input" [(ngModel)]="treatmentFactor.values.length" required=""  [disabled]="disableTreatmentFactor"
													(change)="onValueChanged(treatmentFactor)"/>
                                            </td>
                                        </tr>
                                    } @empty {
                                        <tr>
                                            <td colspan="4" class="text-center text-muted">
                                                <span jhiTranslate="study-editor.variable.table.empty">No variables found.</span>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ng-container>
        </jhi-collapsible>
    </div>
</div>
<div class="row pt-3">
    @for (treatmentFactor of studyEditorContext.studyDetails.treatmentFactors; track treatmentFactor.levelVariable.termId) {
        @if (treatmentFactor.values.length > 0) {
            <div class="row pt-2">
                <div class="col">
                    <div class="card card-body bg-white">
                        <div class="row">
                            <div class="col-6">
                                <div class="row mb-3">
                                    <div class="col">
                                       <span class="fw-bold">{{ (treatmentFactor.levelVariable.alias || treatmentFactor.levelVariable.name) | uppercase }}</span>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col">{{ 'study-editor.treatment-factor.label.treatment' | translate }}</div>
                                    <div class="col">
                                        <span class="value-chip">
                                            <a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                               [queryParams]="{ variableId: treatmentFactor.levelVariable.termId }"
                                               queryParamsHandling="merge">{{ treatmentFactor.levelVariable.alias || treatmentFactor.levelVariable.name }}</a>
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col">{{'study-editor.treatment-factor.label.treatment.label' | translate}}</div>
                                    <div class="col">
                                        <span class="value-chip">
                                            <a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                               [queryParams]="{ variableId: treatmentFactor.valueVariable.termId }"
                                               queryParamsHandling="merge">{{ treatmentFactor.valueVariable.alias || treatmentFactor.valueVariable.name }}</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="row mb-3">
                                    <span class="fw-bold">{{'study-editor.treatment-factor.label.define.label.for.treatment' | translate}}</span>
                                </div>
                                <div class="row mb-2">
									<div class="treatment-factor-scroll-container table-responsive custom-scroll-style">
										<table class="table table-striped table-curved mb-0">
											<thead class="sticky-header">
											<tr>
												<th style="width: 250px;">
													{{'study-editor.treatment-factor.treatment.table.label' | translate}}
												</th>
												<th>
													{{'study-editor.treatment-factor.treatment.table.scale' | translate}}
												</th>
												<th style="width: 250px;">
													{{'study-editor.treatment-factor.treatment.table.value' | translate}}
												</th>
											</tr>
											</thead>
											<tbody>
												@for (leveNumber of createArray(treatmentFactor.values.length); track leveNumber) {
													<tr>
														<td>{{treatmentFactor.valueVariable.name}} {{(leveNumber + 1)}}</td>
														<td>{{treatmentFactor.valueVariable.scale}}</td>
														<td>
															@if (treatmentFactor.valueVariable.dataTypeId === DataTypeIdEnum.CATEGORICAL) {
																@if (disableTreatmentFactor) {
																	<input type="text" class="form-control treatment-factor-text-input" [value]="getCategoricalValueName(treatmentFactor, leveNumber)"
																		   disabled />
																} @else if (treatmentFactor.categoricalValues?.length > 0) {
																	<ng-select  [items]="treatmentFactor.categoricalValues" [(ngModel)]="treatmentFactor.values[leveNumber]"
																				bindValue="id"
																				bindLabel="name"
																				[clearable]="false" required (change)="onValueChanged(treatmentFactor)" >
																	</ng-select>
																} @else {
																	<input type="text" maxlength="255" class="form-control treatment-factor-text-input" [(ngModel)]="treatmentFactor.values[leveNumber]" required
																		(change)="onValueChanged(treatmentFactor)" />
																}
															} @else if (treatmentFactor.valueVariable.dataTypeId === DataTypeIdEnum.NUMERIC) {
																<input type="number" class="form-control treatment-factor-input" [(ngModel)]="treatmentFactor.values[leveNumber]" required  [disabled]="disableTreatmentFactor"
																	   (change)="onValueChanged(treatmentFactor)" />
															} @else if (treatmentFactor.valueVariable.dataTypeId === DataTypeIdEnum.DATE) {
																<div class="input-group">
																	<input class="form-control date-input"
																		   required
																		   [placeholder]="'global.date.no.dash.placeholder' | translate"
																		   [disabled]="disableTreatmentFactor"
																		   [(ngModel)]="treatmentFactor.values[leveNumber]"
																		   [placement]="'auto'"
																		   [container]="'body'"
																		   [autoClose]="true"
																		   (change)="onValueChanged(treatmentFactor)"
																		   ngbDatepicker #datepicker="ngbDatepicker">
																	<button class="btn btn-sm btn-outline-secondary calendar" (click)="datepicker.toggle()"
																			type="button"><i class="fa fa-calendar"></i></button>
																</div>
															} @else {
																<input type="text" maxlength="255" class="form-control treatment-factor-text-input" [(ngModel)]="treatmentFactor.values[leveNumber]" required
																	   [disabled]="disableTreatmentFactor" (change)="onValueChanged(treatmentFactor)"/>
															}
														</td>
													</tr>
												}
											</tbody>
										</table>
									</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    }
</div>
